import dayjs from 'dayjs';

import {
  useChangePaymentPlanMutation,
  useCurrentOrganizationBilling,
} from '@/hooks/useSwr';
import { OrganizationPlanSchema } from '@/types/schema';
import { xCount } from '@/utils/stringUtils';

import { hasValidApprovals } from './helpers';
import { useStatusModals } from './useStatusModals';

export const usePlanTagAttributes = (): {
  setOpen: (modalPlan: string) => React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
  approvals: ReturnType<typeof hasValidApprovals>;
  changePlanTrigger: ReturnType<typeof useChangePaymentPlanMutation>['trigger'];
  changePlanIsMutating: boolean;
  hasPaymentMethod: boolean;
  upcomingPlan: OrganizationPlanSchema | null | undefined;
  currentPlan: OrganizationPlanSchema | null | undefined;
  isPersonal: boolean | undefined;
} => {
  const currentOrganization = useCurrentOrganizationBilling();
  const currentPlan = currentOrganization.data?.current_plan;
  const upcomingPlan = currentOrganization.data?.upcoming_plan;

  const { setOpen, setError } = useStatusModals();

  const approvals = hasValidApprovals(currentOrganization.data);

  const { trigger: changePlanTrigger, isMutating: changePlanIsMutating } =
    useChangePaymentPlanMutation();

  return {
    setOpen,
    setError,
    approvals,
    changePlanTrigger,
    changePlanIsMutating,
    hasPaymentMethod: !!currentOrganization.data?.payment_method,
    upcomingPlan,
    currentPlan,
    isPersonal: currentOrganization.data?.is_personal,
  };
};

export const renderDaysRemaining = (startedOn: Date) => {
  const startOfUTCToday = new Date(dayjs().startOf('day').format('YYYY-MM-DD'));
  const daysRemainingCount = dayjs(startedOn).diff(startOfUTCToday, 'day');

  return xCount('day', daysRemainingCount);
};
